import { exportCsv } from '@/utils/csv/exportCsv'

import {
  mapDocketsToXeroInvoiceRows,
  validateDocketsForXeroExport,
  XERO_INVOICE_CSV_COLUMNS
} from './xeroInvoiceCsvMapper'

function getTimestamp() {
  const now = new Date()

  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')

  return `${year}${month}${day}_${hours}${minutes}`
}

export function exportXeroInvoiceCsv(dockets) {
  const errors = validateDocketsForXeroExport(dockets)

  if (errors.length) {
    return {
      success: false,
      errors
    }
  }

  const rows = mapDocketsToXeroInvoiceRows(dockets)

  exportCsv({
    rows,
    filename: `xero_invoice_import_${getTimestamp()}.csv`,
    columns: XERO_INVOICE_CSV_COLUMNS
  })

  return {
    success: true,
    errors: []
  }
}
